'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('whatwg-fetch');

require('promise-polyfill/dist/polyfill');

var _numberFormatter = require('./numberFormatter.js');

var _numberFormatter2 = _interopRequireDefault(_numberFormatter);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calculateTargetCount(offset, currentNumber, goals) {
  var goal = Math.ceil(currentNumber * (1 + offset));
  goals.sort(function (a, b) {
    return a - b;
  });

  if (goals.length && currentNumber < goals[goals.length - 1]) {
    goal = goals[0];

    for (var goalIndex = 0; goalIndex < goals.length; goalIndex++) {
      if (goals[goalIndex] > currentNumber) {
        goal = goals[goalIndex];
        break;
      }
    }
  }

  return goal;
}

/**
 * @description Renders a progressbar, which raises linearly to goal - (100 * goalOffsetFactor)%.
 * After that the goal will be always (100 * goalOffsetFactor)% above the current count
 * @param {DOMObject} container - Container to render the progress bar in
 * @param {string} endpoint - URL to fetch the data from by GET
 * @param {string} pathToResult - Where to find the number to use inside the response
 * @param {IETF BCP 47 language tag} language - Define language to format number properly
 * @param {number} goal - To which amount of signatures the progressbar should be properly increased
 * @param {number} goalOffsetFactor - Factor which should be used to calculate the new goal if {goal} was reached
 * @param {string} label - text to show after the counter
 * @param {string} labelGoal - text to show after the counter describing the goal
 * @param {number} offset
 * @param {number[]} goals
 */

exports.default = function (container, endpoint, pathToResult, language, goalOffsetFactor, label, labelGoal, offset) {
  var goals = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];

  container.style.display = 'none';

  window.fetch(endpoint, {
    method: 'GET'
  }).then(function (response) {
    response.json().then(function (result) {
      var currentNumber = parseInt((0, _lodash2.default)(result, pathToResult, null), 10);
      var parsedOffset = parseInt(offset, 10);

      if (!isNaN(currentNumber)) {
        container.style.display = 'block';

        if (!isNaN(parsedOffset)) {
          currentNumber += parsedOffset;
        }

        var goal = calculateTargetCount(goalOffsetFactor, currentNumber, goals);

        container.innerHTML = '\n          <div class="progress-bar" style="opacity: 0">\n            <div class="progress-bar__bar progress-bar__bar--target"></div>\n            <div class="progress-bar__bar progress-bar__bar--current"></div>\n            <div class="progress-bar__text">\n              <strong>' + _numberFormatter2.default.toFormatted(language, currentNumber) + '</strong> ' + label + '\n            </div>\n            ' + (labelGoal ? '<div class="progress-bar__goal">\n                ' + (labelGoal && labelGoal.replace('{goal}', '<strong>' + _numberFormatter2.default.toFormatted(language, goal) + '</strong>')) + '\n              </div>' : '') + '\n          </div>';

        window.setTimeout(function () {
          container.getElementsByClassName('progress-bar')[0].style.opacity = 1;
          container.getElementsByClassName('progress-bar__bar progress-bar__bar--current')[0].style.width = currentNumber / goal * 100 + '%';
        }, 50);
      }
    });
  });
};